<button
  class="follow community-button"
  [class.normal-size]="size() === 'normal'"
  [class.is-followed]="$profile().is_following"
  (click)="followButtonClick()"
  [disabled]="isLoading()"
>
  @if (size() === 'normal') {
    <outlaw-icon name="plusInCircle" size="16px" class="icon"></outlaw-icon>
  }
  <span class="text">{{ $profile().is_following ? 'Following' : 'Follow' }}</span>

  <span class="text-hover">Unfollow?</span>
</button>
